<template>
    <div>
        <section>
            <div class="container">
                <img :src="productLine.logo" :title="productLine.name" class="img-logo" /><sup class="text-black text-h5 text-weight-bold on-right" style="vertical-align: top">{{ productLine.year }}</sup>
                <div class="row q-col-gutter-lg justify-between q-pt-sm">
                    <div class="col-xs-12 col-md-7 q-mb-md">
                        <p>
                            PlumbingCAD is a drawing based software for the fast takeoff and quoting of PEX plumbing systems for residential and commercial projects. PlumbingCAD is easy to learn and previous CAD experience is not required. View the Video Demo for a quick introduction, and the <router-link :to="product.tutorial">Tutorial</router-link> lessons provide a much more in-depth look.
                        </p>
                        <div class="row q-col-gutter-sm">
                            <div class="col-xs-12 col-sm-auto">
                                <q-btn color="primary"
                                       :to="product.tutorial"
                                       label="Tutorial"
                                       icon="mdi-school"
                                       class="full-width" />
                            </div>
                            <div class="col-xs-12 col-sm-auto">
                                <q-btn class="full-width bg-white text-primary"
                                       style="border: 1px solid currentColor; height: 95%;"
                                       label="Free Trial" icon="mdi-download"
                                       @click="ScrollTo($refs.trialRef, '#trial')" />
                            </div>
                            <div class="col-xs-12 col-sm-auto">
                                <q-btn label="Pricing" color="positive" icon="mdi-cart"
                                       :to="{ name:'/store', params: { productLine: 'plumbingcad'}}"
                                       class="full-width" />
                            </div>
                            <div class="col-xs-12 col-sm-auto">
                                <q-btn label="Activate" color="positive" icon="mdi-lock-open-variant"
                                       to="/activation/plumbingcad"
                                       class="full-width" />
                            </div>
                            <div class="lt-md col-xs-12 col-sm-auto">
                                <q-btn label="View Demo" color="secondary" icon="mdi-video"
                                       class="full-width"
                                       @click="showVideo = true" />
                            </div>
                        </div>
                        <p class="text-caption text-grey q-mt-xl q-mb-none">
                            PlumbingCAD is intended for use by professionals that have knowledge and experience with the calculations required for proper plumbing system design. It is not intended for DIY users that may not be adequately trained in these areas.
                        </p>
                    </div>

                    <div class="gt-sm col-xs-12 col-md-5">
                        <div class="column" :class="{'items-end' : !screenSize.xs, 'items-center' : screenSize.lt.md}">
                            <div @click="showVideo = true" class="cursor-pointer demo text-center">
                                <img src="https://www.avenir-online.com/AvenirWeb/PlumbingCAD/Tutorials/Introduction/Intro2018_PC.png" class="img-intro" title="Introduction" />
                                <div class="overlay"><q-icon name="mdi-play-circle" color="grey-7" size="5em"></q-icon></div>
                            </div>
                        </div>
                        <dialog-video-player :show.sync="showVideo" title="Introduction to PlumbingCAD" src="https://www.avenir-online.com/AvenirWeb/PlumbingCAD/Tutorials/Introduction/PlumbingCAD%20Introduction_2018.mp4" />
                    </div>
                </div>
            </div>
        </section>

        <features :productLine="productLine" />
        <div id="trial" ref="trialRef">
            <free-trial :productLine="productLine" />
        </div>
        <license-subscription-info :productLine="productLine" />
        <system-requirements :sysReq="productLine.sysReq" />
    </div>
</template>
<script>
    import licenseSubscriptionInfo from '@/components/LicenseSubscriptionInfo'
    import systemRequirements from '@/components/SystemRequirements'
    import features from '@/components/ProductFeatures'
    import freeTrial from '@/components/FreeTrial'
    import { productTypes } from '@/plugins/productTypes'
    import { productLines } from '@/plugins/productLines'
    import dialogVideoPlayer from '@/components/dialogs/DialogVideoPlayer'

    export default {
        name: 'plumbingcad',
        components: {
            dialogVideoPlayer,
            licenseSubscriptionInfo,
            systemRequirements,
            features,
            freeTrial,
        },
        data() {
            return {
                showVideo: false,
                productLine: productLines.PlumbingCAD,
                product: productTypes[0].products?.find(({ name }) => name === 'PlumbingCAD'),
            }
        },
        methods: {
            ScrollTo(element, hash) {
                const currentHash = this.$route.hash;
                const targetHash = hash;

                if (currentHash !== targetHash) {
                    this.scrollToElement(element);
                    this.$router.push({ path: this.$route.path + "/", hash: targetHash });
                } else {
                    this.scrollToElement(element);
                }
            },
        },
        computed: {
            screenSize() {
                return this.$q.screen
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/quasar.variables.scss";

    @media (max-width: $breakpoint-xs-max) {
        .img-logo {
            max-height: 55px;
        }
    }

    .img-intro {
        width: 450px;
        width: 100%;
    }

    .overlay {
        position: absolute;
        top: 30%;
        bottom: 0;
        left: 0;
        right: 0;
    }

    .demo {
        position: relative;
        max-width: 450px;
    }
</style>
